export default "__VITE_ASSET__Dd2X0884__"